import { render, staticRenderFns } from "./MicrochipTables.vue?vue&type=template&id=1fe19fc6&"
import script from "./MicrochipTables.vue?vue&type=script&lang=js&"
export * from "./MicrochipTables.vue?vue&type=script&lang=js&"
import style0 from "./MicrochipTables.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports